import { connect } from 'react-redux';
import ModalParametersForm from './ModalParametersForm';
import { addParameters } from '../../../redux/actions';
import {
  ticketscanLimitSelector,
  isTicketscanUnlimitedSelector,
  newTicketscanSelector,
} from '../../../redux/selectors/featureActionsSelector';

const mapStateToProps = state => ({
  ticketscanLimit: ticketscanLimitSelector(state),
  isTicketscanUnlimited: isTicketscanUnlimitedSelector(state),
  newTicketscanOptions: newTicketscanSelector(state),
});

const mapDispatchToProps = {
  addParameters,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
  initialValues: {
    ...stateProps.newTicketscanOptions,
    scanCountLimit: stateProps.newTicketscanOptions.scanCountLimit > -1
      ? stateProps.newTicketscanOptions.scanCountLimit
      : null,
  },
  onSubmit: (values) => {
    dispatchProps.addParameters({
      newTicketscanOptions: {
        ...stateProps.newTicketscanOptions,
        ...values,
      },
    });
  },
});


export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps,
)(ModalParametersForm);



// WEBPACK FOOTER //
// ./src/js/common/components/ModalParametersForm/TicketscanLimitForm.js